/** Маршрут песочницы с демо-проектом. `?autoplay=1` проигрывает сценарий сам (запись роликов). */
export const DEMO_PATH = "/onboarding/demo";
